import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import AuthLayout from '../../components/AuthLayout';
import Logo from '../../assets/images/logo.png';
import UserIcon from '../../components/icons/UserIcon';
import { useAuth } from '../../contexts/AuthContext';
import { NotificationManager } from 'react-notifications';

const ForgotPassword = () => {
  const { currentUser, passwordReset } = useAuth();

  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSendEmail = () => {
    setError('');
    setLoading(true);

    console.log(email);

    passwordReset(email)
      .then((ref) => {
        setLoading(false);
        NotificationManager.success(`Password Reset Email has been sent to ${email}`, 'Success!');
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
        console.log(err);
      });
  };

  return (
    <AuthLayout>
      <div className="forgot-password">
        <div className="auth-container">
          <div className="half-section">
            <div className="auth-text">
              <img src={Logo} alt="" className="logo" />
              <h1>
                Hello, Welcome to <span>We All Count’s</span> Funding Web tool.
              </h1>
            </div>
          </div>
          <div className="half-section">
            <div className="auth-card">
              <h2>Forgot your Password?</h2>
              <p className="guide-text">Don’t have an account?</p>
              <div className="auth-form">
                <div className="main-image">
                  <UserIcon color={'#594FD1'} />
                </div>
                <div className="main-input">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>
              <div className="actions">
                <button className="primary-btn" onClick={handleSendEmail}>
                  Send
                </button>
              </div>
              <div className="text-center">
                <Link to="/" className="link">
                  Go Back to log in
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
